import Identificacion from "../Comun/Identificacion";


export  class ParametrosActualizaSolicitud {

    constructor() {
        this.Solicitud = 0;
        this.IdPersonaTramite = new Identificacion();
        this.NombreORazonSocial = "";
        this.PrimerApellido = "";
        this.SegundoApellido = "";
        this.FechaNacORegistro = "";
        this.PaisNacORegistro = "";
        this.Genero = "";
        this.ListaDocumentos = [];
    }

    Solicitud: number;
    IdPersonaTramite: Identificacion;
    NombreORazonSocial: string;
    PrimerApellido: string;
    SegundoApellido: string;
    FechaNacORegistro: string;
    PaisNacORegistro: string;
    Genero: string;
    ListaDocumentos:[]

}